/*import { HttpClient, HttpParams } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { StorageService } from '../storage-service/storage.service';
import { Observable, tap } from 'rxjs';
import { Jornada } from 'src/app/models/jornada';

@Injectable({
  providedIn: 'root'
})
export class JornadaService {

  private apiUrl: string = ''; // Inicializa apiUrl como uma string vazia
    private storageService = inject(StorageService);

  constructor(private http: HttpClient) {
    this.initApiUrl(); // Chama o método para inicializar a URL da API ao criar o serviço
  }

  // Método para inicializar a URL da API, buscando no IndexedDB
  private async initApiUrl() {
    try {
      // Recupera a URL do servidor (apiUrl) do IndexedDB
      const servidor = await this.storageService.getServidor();
      //console.log('Servidor recuperado:', servidor); 

      if (servidor && servidor.url_servidor) {
        this.apiUrl = `${servidor.url_servidor}/jornada`; // Define a URL completa da API
        //console.log('API URL definida para:', this.apiUrl);
      } else {
        // Caso não tenha a URL salva, define um valor padrão
        this.apiUrl = 'https://i9fluir.com.br:8082/api/jornada';
        //console.log('Nenhuma URL encontrada, usando a URL padrão:', this.apiUrl);
      }
    } catch (error) {
      console.error('Erro ao buscar a URL da API no IndexedDB:', error);
      // Define uma URL padrão em caso de erro
      this.apiUrl = 'https://i9fluir.com.br:8082/api/jornada';
    }
  }

  // Método para retornar a URL do servidor
  getUrlServidor(): string {
    return this.apiUrl;
  }

  // Método para iniciar jornada
  iniciarJornada(usuario_id: number, folhaServicoId: number, dataServico:string, horaInicial: number, resumoPapeletaEmpregadoId: number, numeroPapeleta: number, latitude: number, longitude: number, horarioInicial: number, horarioFinal: number): Observable<any> {
    const body = {
      usuario_id: usuario_id,
      folha_servico_id: folhaServicoId,
      data_servico: dataServico,
      hora_inicial: horaInicial,
      resumo_papeleta_empregado_id: resumoPapeletaEmpregadoId,
      numero_papeleta: numeroPapeleta,
      latitude_inicio: latitude,
      longitude_inicio: longitude,
      horario_inicial: horarioInicial,
      horario_final: horarioFinal
    };
    return this.http.post(`${this.apiUrl}/iniciar`, body);
  }

  // Método para finalizar jornada
  finalizarJornada(usuario_id: number, numeroPapeleta: number, latitude: number, longitude: number, horaFinal: number, observacao: string): Observable<any> {
    const body = {
      usuario_id: usuario_id,
      numero_papeleta: numeroPapeleta,
      latitude_fim: latitude,
      longitude_fim: longitude,
      hora_final: horaFinal,
      observacao: observacao
    };
    return this.http.put(`${this.apiUrl}/finalizar`, body);
  }

  // Método para listar jornada por data e papeleta
  listarJornada(numero_papeleta: number, dataServico: string): Observable<Jornada[]> {
    const params = new HttpParams()
      .set('numero_papeleta', numero_papeleta.toString())
      .set('data_servico', dataServico);

    return this.http.get<Jornada[]>(`${this.apiUrl}/listar`, { params });
  }

  trocarVeiculo(jornadaId: number, numeroVeiculo: number, motivo: string, hodometroFimAnterior: number, hodometroInicioNovo: number, dataHoraTroca: string): Observable<any> {
    const body = {
      jornadaId: jornadaId,
      numeroVeiculo: numeroVeiculo,
      motivo: motivo,
      hodometroFimAnterior: hodometroFimAnterior,
      hodometroInicioNovo: hodometroInicioNovo,
      dataHoraTroca: dataHoraTroca
    };
    return this.http.post(`${this.apiUrl}/trocar-veiculo`, body);
  }

  listarJornadasPorData(dataServico: string): Observable<Jornada[]> {
    const params = new HttpParams().set('data_servico', dataServico);
    return this.http.get<Jornada[]>(`${this.apiUrl}/listar-por-data`, { params });
  }

}*/

import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Jornada } from 'src/app/models/jornada';

@Injectable({
  providedIn: 'root'
})
export class JornadaService {

  constructor(private http: HttpClient) {}

  iniciarJornada(
    usuario_id: number,
    folhaServicoId: number,
    dataServico: string,
    horaInicial: number,
    resumoPapeletaEmpregadoId: number,
    numeroPapeleta: number,
    latitude: number,
    longitude: number,
    horarioInicial: number,
    horarioFinal: number
  ): Observable<any> {

    const body = {
      usuario_id,
      folha_servico_id: folhaServicoId,
      data_servico: dataServico,
      hora_inicial: horaInicial,
      resumo_papeleta_empregado_id: resumoPapeletaEmpregadoId,
      numero_papeleta: numeroPapeleta,
      latitude_inicio: latitude,
      longitude_inicio: longitude,
      horario_inicial: horarioInicial,
      horario_final: horarioFinal
    };

    return this.http.post(`/jornada/iniciar`, body);
  }

  finalizarJornada(
    usuario_id: number,
    numeroPapeleta: number,
    latitude: number,
    longitude: number,
    horaFinal: number,
    observacao: string
  ): Observable<any> {

    const body = {
      usuario_id,
      numero_papeleta: numeroPapeleta,
      latitude_fim: latitude,
      longitude_fim: longitude,
      hora_final: horaFinal,
      observacao
    };

    return this.http.put(`/jornada/finalizar`, body);
  }

  listarJornada(numero_papeleta: number, dataServico: string): Observable<Jornada[]> {

    const params = new HttpParams()
      .set('numero_papeleta', numero_papeleta.toString())
      .set('data_servico', dataServico);

    return this.http.get<Jornada[]>(`/jornada/listar`, { params });
  }

  listarJornadasPorData(dataServico: string): Observable<Jornada[]> {

    const params = new HttpParams()
      .set('data_servico', dataServico);

    return this.http.get<Jornada[]>(`/jornada/listar-por-data`, { params });
  }

  trocarVeiculo(
    jornadaId: number,
    numeroVeiculo: number,
    motivo: string,
    hodometroFimAnterior: number,
    hodometroInicioNovo: number,
    dataHoraTroca: string
  ): Observable<any> {

    const body = {
      jornadaId,
      numeroVeiculo,
      motivo,
      hodometroFimAnterior,
      hodometroInicioNovo,
      dataHoraTroca
    };

    return this.http.post(`/jornada/trocar-veiculo`, body);
  }

}
